/**
 * Talaba varianti: seed → deterministik parametrlar to'plami.
 * Bir xil (lab.id, lab.version, seed) → doim bir xil variant, shuning uchun
 * server qayta hisoblashi mumkin va talabalar bir-biridan ko'chira olmaydi.
 */
import { createRng } from '../random/prng';
import type { LabDefinition } from './schema';
import { roundTo, substituteRefs } from './path';

export interface ResolvedLab {
  lab: LabDefinition;
  seed: string;
  /** Variant qiymatlari nomi bo'yicha */
  variant: Record<string, number | string>;
  /** "$" almashtirilgan apparat parametrlari */
  params: Record<string, unknown>;
  /** "$" almashtirilgan boshlang'ich kirishlar */
  inputs: Record<string, unknown>;
}

export function generateVariant(lab: LabDefinition, seed: string): Record<string, number | string> {
  const rng = createRng(`${lab.id}@${lab.version}#${seed}`);
  const out: Record<string, number | string> = {};
  // Tartib deterministik bo'lishi uchun kalitlar saralanadi
  for (const name of Object.keys(lab.variant).sort()) {
    const spec = lab.variant[name] as LabDefinition['variant'][string];
    if ('choices' in spec) {
      out[name] = rng.pick(spec.choices);
    } else {
      const decimals = Math.max(0, -Math.floor(Math.log10(spec.step)) + 2);
      out[name] = roundTo(rng.uniformStep(spec.min, spec.max, spec.step), decimals);
    }
  }
  return out;
}

/**
 * Apparat parametrlarini ochish hook'i (masalan kutubxona reaksiyasi havolasi). Reyestr
 * (scenario/registry.ts) yuklanganda o'rnatiladi — aylanma import bo'lmasligi uchun bu modul
 * reyestrni bevosita import qilmaydi.
 */
export type ParamsResolver = (unit: string, params: Record<string, unknown>) => Record<string, unknown>;
let paramsResolver: ParamsResolver = (_unit, params) => params;
export function setParamsResolver(fn: ParamsResolver): void {
  paramsResolver = fn;
}
function resolveUnitParams(unit: string, params: Record<string, unknown>): Record<string, unknown> {
  return paramsResolver(unit, params);
}

export function resolveLab(lab: LabDefinition, seed: string): ResolvedLab {
  const variant = generateVariant(lab, seed);
  return {
    lab,
    seed,
    variant,
    params: resolveUnitParams(lab.unit, substituteRefs(lab.params, variant) as Record<string, unknown>),
    inputs: substituteRefs(lab.inputs, variant) as Record<string, unknown>,
  };
}
